<template>
    <slot></slot>
    <nav
        v-show="!noData"
        id="pagination_nav"
        class="d-md-flex justify-content-center justify-content-md-start align-items-center px-md-2 pagination-block"
        :class="classes"
    >
        <ul
            v-if="!noData"
            class="pagination mb-0 d-flex justify-content-center justify-content-md-start"
            style="cursor: pointer"
        >
            <li class="page-item" :class="disablePrevious ? 'disabled cursor-disabled' : ''">
                <span class="page-link" @click="decrementPageNumber()">
                    <i class="fas fa-caret-left"></i>
                </span>
            </li>

            <li
                v-for="(page, index) in currentNavPages"
                class="page-item"
                :class="page === currentPage ? 'active fw-bold' : ''"
                :key="`navpage-${index}`"
            >
                <span @click="changePage(page)" class="page-link"> {{ page }} </span>
            </li>

            <li :class="disableNext ? 'disabled cursor-disabled' : ''" class="page-item">
                <span class="page-link" @click="incrementPageNumber()">
                    <i class="fas fa-caret-right"></i>
                </span>
            </li>
        </ul>
        <span v-if="!noData" class="ms-2 fw-bold d-block d-md-inline text-center text-md-start my-2 my-md-0"
            >Viewing {{ from }} - {{ to }} out of {{ totalDataCount }} total {{ entity }}</span
        >
        <slot name="legend"></slot>
        <span
            class="fw-bold ms-auto d-flex justify-content-center align-items-center"
            v-if="showPageSizeOptions && !noData"
        >
            Show
            <select class="form-select w-auto d-inline mx-1" v-model="pageOrder" @change="updatePageSize()">
                <option v-for="(option, index) in pageSizeOptions" :key="`size-option-${index}`">
                    {{ option }}
                </option>
            </select>
            entries
        </span>
    </nav>
</template>

<style src="./Pagination.scss"></style>
<script src="./Pagination.ts"></script>
